import { CurrencyCode, ToggleOptionWithPeriod } from '@types';
import {
  USIndexPerformanceState,
  USIndexPerformanceView,
} from '../types/us-index.type';

export const USIndexDateRangeInitialValuesForHistorical: Map<
  string,
  ToggleOptionWithPeriod
> = new Map([
  [
    'MTD',
    {
      active: true,
      value: 'MTD',
      text: 'us-index-timeperiod-mtd',
    },
  ],
  [
    'QTD',
    {
      active: false,
      value: 'QTD',
      text: 'us-index-timeperiod-qtd',
    },
  ],
  [
    'YTD',
    {
      active: false,
      value: 'YTD',
      text: 'us-index-timeperiod-ytd',
    },
  ],
  [
    'ONE_YEAR',
    {
      active: false,
      value: 'ONE_YEAR',
      text: 'us-index-timeperiod-1-year',
      period: {
        key: 'years',
        value: 1,
      },
    },
  ],
  [
    'TWO_YEARS',
    {
      active: false,
      value: 'TWO_YEARS',
      text: 'us-index-timeperiod-2-years',
      period: {
        key: 'years',
        value: 2,
      },
    },
  ],
  [
    'THREE_YEARS',
    {
      active: false,
      value: 'THREE_YEARS',
      text: 'us-index-timeperiod-3-years',
      period: {
        key: 'years',
        value: 3,
      },
    },
  ],
  [
    'FIVE_YEARS',
    {
      active: false,
      value: 'FIVE_YEARS',
      text: 'us-index-timeperiod-5-years',
      period: {
        key: 'years',
        value: 5,
      },
    },
  ],
  [
    'SEVEN_YEARS',
    {
      active: false,
      value: 'SEVEN_YEARS',
      text: 'us-index-timeperiod-7-years',
      period: {
        key: 'years',
        value: 7,
      },
    },
  ],
  [
    'TEN_YEARS',
    {
      active: false,
      value: 'TEN_YEARS',
      text: 'us-index-timeperiod-10-years',
      period: {
        key: 'years',
        value: 10,
      },
    },
  ],
  [
    'SINCE_INCEPTION',
    {
      active: false,
      value: 'SINCE_INCEPTION',
      text: 'us-index-timeperiod-since-inception',
    },
  ],
  [
    'CUSTOM_RANGE',
    {
      active: false,
      value: 'CUSTOM_RANGE',
      text: 'custom-range',
    },
  ],
]);

export const USIndexDateRangeInitialValuesForGrowth10k: Map<
  string,
  ToggleOptionWithPeriod
> = new Map([
  [
    'ONE_YEAR',
    {
      active: false,
      value: 'ONE_YEAR',
      text: 'us-index-timeperiod-1-year',
      period: {
        key: 'years',
        value: 1,
      },
    },
  ],
  [
    'THREE_YEARS',
    {
      active: false,
      value: 'THREE_YEARS',
      text: 'us-index-timeperiod-3-years',
      period: {
        key: 'years',
        value: 3,
      },
    },
  ],
  [
    'FIVE_YEARS',
    {
      active: false,
      value: 'FIVE_YEARS',
      text: 'us-index-timeperiod-5-years',
      period: {
        key: 'years',
        value: 5,
      },
    },
  ],
  [
    'TEN_YEARS',
    {
      active: false,
      value: 'TEN_YEARS',
      text: 'us-index-timeperiod-10-years',
      period: {
        key: 'years',
        value: 10,
      },
    },
  ],
  [
    'SINCE_INCEPTION',
    {
      active: false,
      value: 'SINCE_INCEPTION',
      text: 'us-index-timeperiod-since-inception',
    },
  ],
  [
    'CUSTOM_RANGE',
    {
      active: false,
      value: 'CUSTOM_RANGE',
      text: 'custom-range',
    },
  ],
]);

// Initialize default values to state.
export const US_INDEX_PERFORMANCE_INITIAL_STATE: USIndexPerformanceState = {
  data: {
    daily: null,
    indexLevels: [],
    custom: null,
    timeSeries: null,
    indexDetails: null,
  },
  config: {
    asOfDate: null,
    asOfDateStd: null,
    incDateStd: null,
    currencyCode: CurrencyCode.USD,
    chartConfig: {
      dateRangeEnum: null,
      selectedToggleRange: 'SINCE_INCEPTION', // Intentionally set it as default (Ref: story criteria).
      customRange: {
        fromDateStd: null,
        toDateStd: null,
        fromDate: null,
        toDate: null,
      },
      chartTitle: null,
      proximalPlacementTop: null,
      proximalPlacementBottom: null,
      caveatPlacement: null,
      tooltip: null,
      highChartOptions: {
        series: null,
      },
      seriesName: null,
      annualizedReturn: null,
    },
    selectedPerformanceView: USIndexPerformanceView.MONTHLY,
  },
};
